import { breakpoints } from './breakpoints';
import { colors, opacity, colorsPalette } from './colors';
import fonts from './fonts';
import { scrollbarStyles } from './scrollbar';

export const theme = {
  breakpoints,
  colors,
  colorsPalette,
  fonts,
  opacity,
  scrollbar: scrollbarStyles,
};

export default theme;
